var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect } from "react";
import ChatMessage from "./ChatMessage";
import { AppContext } from "../appContext";
import TimeAgo from "../Timeago";
import { DEFAULT_BOT_ICON } from "../globals";
var GPTChatMessage = function (props) {
    var getmessageTime = function () {
        return props.message.created_time * 1000;
    };
    useEffect(function () {
        return function () { };
    }, []);
    var parentContext = useContext(AppContext);
    var getIcon = function () {
        var _a, _b;
        if ((_a = parentContext.chatPrefs.matchedBotPrefs) === null || _a === void 0 ? void 0 : _a.id)
            return (_b = parentContext.chatPrefs.matchedBotPrefs) === null || _b === void 0 ? void 0 : _b.settings.chatBotIconURL;
        return DEFAULT_BOT_ICON;
    };
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "chat__messages-group" }, { children: _jsxs("div", __assign({ className: "chat__messages-agent-info" }, { children: [_jsxs("div", __assign({ className: "chat__messages-agent" }, { children: [_jsx("div", __assign({ className: "chat__messages-agent-avatar" }, { children: _jsx("img", { src: getIcon(), alt: "Avatar" }) })), _jsx("ul", __assign({ className: "chat__messages-list" }, { children: _jsx("li", __assign({ className: "chat__messages-list-item" }, { children: _jsx(ChatMessage, { sessionId: props.sessionId, message: props.message, updateMessage: props.updateMessage, executeAiAction: props.executeAiAction ? props.executeAiAction : null }) })) }))] })), _jsx("div", __assign({ className: "chat__messages-timestamp" }, { children: _jsx(TimeAgo, { date: getmessageTime() }) }))] })) })) }));
};
export default GPTChatMessage;
